import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { Haptics } from '@capacitor/haptics';
import { HudHaptics } from '@huddle-sports-platform/ui';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideIonicAngular(),
    provideRouter(routes, withComponentInputBinding()),
    // Wire the real Capacitor plugin into the kit's haptics service - the
    // kit cannot resolve it from a bundle at runtime (it keeps no hard
    // dependency), and without this every hud-button tap no-ops on device.
    provideAppInitializer(() => inject(HudHaptics).use(Haptics)),
  ],
};
